"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _locales = require("../utils/locales");
const messages = exports.messages = {
  [_locales.locales.en]: {
    prev: "Go to previous page",
    next: "Go to next page",
    first: "Jump to first page",
    last: "Jump to last page",
    page: "Go to page {0} of {1}",
    onpage: "On page {0} of {1}",
    disabled: "Disabled"
  },
  [_locales.locales.es]: {
    prev: "Regresar a la pagina anterior",
    next: "Ir a la página siguiente",
    first: "Saltar a la primera página",
    last: "Saltar a la última página",
    page: "Ir a la página {0} de {1}",
    onpage: "En la página {0} de {1}",
    disabled: "Desactivado"
  },
  [_locales.locales.fr]: {
    prev: "Aller à la page précédente",
    next: "Aller à la page suivante",
    first: "Aller à la première page",
    last: "Aller à la dernière page",
    page: "Aller à la page {0} sur {1}",
    onpage: "À la page {0} de {1}",
    disabled: "Désactivé"
  },
  [_locales.locales.pt]: {
    prev: "Ir para a página anterior",
    next: "Ir para a próxima página",
    first: "Saltar para a primeira página",
    last: "Ir para a última página",
    page: "Ir para a página {0} de {1}",
    onpage: "Na página {0} de {1}",
    disabled: "Desabilitado"
  },
  [_locales.locales.zh]: {
    prev: "轉到上一頁",
    next: "轉到下一頁",
    first: "跳轉到第一頁",
    last: "跳轉到最後一頁",
    page: "轉到第 {0} 頁（共 {1} 頁）",
    onpage: "在第 {0} 頁，共 {1} 頁",
    disabled: "殘障人士"
  },
  [_locales.locales.de]: {
    prev: "Gehe zur vorherigen Seite",
    next: "Gehe zur nächsten Seite",
    first: "Zur ersten Seite springen",
    last: "Zur letzten Seite springen",
    page: "Gehe zu Seite {0} von {1}",
    onpage: "Auf Seite {0} von {1}",
    disabled: "Deaktiviert"
  },
  [_locales.locales.it]: {
    prev: "Vai alla pagina precedente",
    next: "Vai alla pagina successiva",
    first: "Vai alla prima pagina",
    last: "Vai all'ultima pagina",
    page: "Vai alla pagina {0} di {1}",
    onpage: "Nella pagina {0} di {1}",
    disabled: "Disabilitato"
  },
  [_locales.locales.ja]: {
    prev: "前のページに移動",
    next: "次のページに移動",
    first: "最初のページにジャンプ",
    last: "最後のページにジャンプ",
    page: "ページ {0} / {1} へ移動",
    onpage: "{1} ページ中 {0} ページ目",
    disabled: "無効"
  },
  [_locales.locales.tl]: {
    prev: "Pumunta sa nakaraang pahina",
    next: "Pumunta sa susunod na pahina",
    first: "Tumalon sa unang pahina",
    last: "Tumalon sa huling pahina",
    page: "Pumunta sa pahina {0} ng {1}",
    onpage: "Nasa pahina {0} ng {1}",
    disabled: "Hindi pinagana"
  },
  [_locales.locales.hi]: {
    prev: "पिछले पृष्ठ पर जाएँ",
    next: "अगले पृष्ठ पर जाएँ",
    first: "पहले पृष्ठ पर जाएँ",
    last: "अंतिम पृष्ठ पर जाएँ",
    page: "पृष्ठ {0} से {1} पर जाएँ",
    onpage: "पृष्ठ {0} का {1}",
    disabled: "अक्षम"
  },
  [_locales.locales.ko]: {
    prev: "이전 페이지로 이동",
    next: "다음 페이지로 이동",
    first: "첫 페이지로 이동",
    last: "마지막 페이지로 이동",
    page: "{1}의 페이지 {0}로 이동",
    onpage: "{1}의 페이지 {0}",
    disabled: "비활성화됨"
  }
};